import React, {useState, useEffect} from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import axios from "axios";
import {FLIGHT_API_HEADERS} from "@/services/flightService";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {ModalFooter} from "../Components/BookingModalShell.jsx";
import {rideDateYMD as formatDateYMD} from "@/utils/dateUtils.js";

const BASE_URL = "https://aerodatabox.p.rapidapi.com";

export function FlightAirportLists(props) {
    const [airportName, setAirportName] = useState(null);
    const [query, setQuery] = useState("");
    const [originAirports, setOriginAirports] = useState([]);
    const [searchResults, setSearchResults] = useState([]);
    const [selectedAirport, setSelectedAirport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [initialLoading, setInitialLoading] = useState(true);

    useEffect(() => {
        const storedAirportDetails = storage.get(STORAGE_KEYS.AIRPORT_DETAILS);
        const storedUserDeparture = storage.get(STORAGE_KEYS.DEPARTURE_AIRPORT);

        if (storedAirportDetails) setAirportName(storedAirportDetails);

        if (storedUserDeparture) {
            setSelectedAirport(storedUserDeparture);
            setQuery(`${storedUserDeparture.name} (${storedUserDeparture.iata})`);
        }
    }, []);

    const rideDate = storage.get(STORAGE_KEYS.RIDE_DATE);
    const fromLocal = rideDate ? `${formatDateYMD(rideDate)}T00:00` : null;
    const toLocal = rideDate ? `${formatDateYMD(rideDate)}T23:59` : null;

    useEffect(() => {
        if (!airportName?.code || !fromLocal || !toLocal) return;

        const fetchOriginsToDeparture = async () => {
            setInitialLoading(true);
            try {
                const res = await axios.get(
                    `${BASE_URL}/flights/airports/iata/${airportName.code}/${fromLocal}/${toLocal}`,
                    {headers: FLIGHT_API_HEADERS, params: {direction: "Arrival"}}
                );
                const arrivals = res.data?.arrivals || [];
                const origins = arrivals.map(f => f?.movement?.airport?.iata).filter(Boolean);
                setOriginAirports([...new Set(origins)]);
            } catch (err) {
                console.error(err);
                setOriginAirports([]);
            } finally {
                setInitialLoading(false);
            }
        };

        fetchOriginsToDeparture();
    }, [airportName, fromLocal, toLocal]);

    useEffect(() => {
        if (!query || query.length < 3) {
            setSearchResults([]);
            return;
        }

        const fetchAirports = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${BASE_URL}/airports/search/term`, {
                    headers: FLIGHT_API_HEADERS,
                    params: {q: query, limit: 20},
                });
                const airports = res.data.items || [];
                if (originAirports.length > 0) {
                    const filtered = airports.filter(a => originAirports.includes(a.iata));
                    setSearchResults(filtered);
                } else {
                    setSearchResults(airports);
                }
            } catch (err) {
                console.error(err);
                setSearchResults([]);
            } finally {
                setLoading(false);
            }
        };

        const debounce = setTimeout(fetchAirports, 300);
        return () => clearTimeout(debounce);
    }, [query, originAirports]);

    return (
        <>
            <ModalHeader
                title="Flight Details"
                extraClasses=""
                totalSteps={1}
                cancelButton={false}
                cancelButtonType="text"
                backStep="flightAirportTo"
                showBackButton={true}
                enableEditModeOnBackButton={false}
                setStep={props.setStep}
                closeModal={props.closeModal}
            />

            <div className="hopn-airports modalPages-spacing">
                <div className="hopn-airports-selected">
                    <div className="hopn-airports-inner">
                        <input
                            type="text"
                            name="starting-airport"
                            placeholder="Destination Airport"
                            value={airportName ? `${airportName.name} (${airportName.code})` : ""}
                            readOnly
                        />
                    </div>
                    <div className="hopn-airports-inner">
                        <input
                            type="text"
                            placeholder="Type departure airport name..."
                            value={query}
                            onChange={(e) => {
                                setQuery(e.target.value);
                                setSelectedAirport(null);
                                storage.remove(STORAGE_KEYS.DEPARTURE_AIRPORT);
                            }}
                        />
                    </div>
                </div>

                <div className="hopn-airports-list">
                    <ul>
                        {initialLoading ? (
                             <li className="hopn-no-results">Loading available origin airports...</li>
                        ) : loading ? (
                            <li className="hopn-no-results">Searching...</li>
                        ) : searchResults.length > 0 ? (
                            searchResults.map((airport) => (
                                <li
                                    key={airport.iata}
                                    onClick={() => {
                                        setSelectedAirport(airport);
                                        setQuery(`${airport.name} (${airport.iata})`);
                                        storage.set(STORAGE_KEYS.DEPARTURE_AIRPORT, airport);
                                    }}
                                >
                                    {airport.name} <span>Airport ({airport.iata})</span>
                                </li>
                            ))
                        ) : query.length >= 3 ? (
                            <li className="hopn-no-results">No results found</li>
                        ) : (
                            <li className="hopn-no-results">Continue typing to search for an airport.</li>
                        )}
                    </ul>
                </div>
            </div>
            <ModalFooter>
                <button
                    className="hopn-add-passenger-button"
                    disabled={!selectedAirport}
                    onClick={() => {
                        if (selectedAirport) props.setStep("flightAirlines");
                    }}
                >Continue
                </button>
            </ModalFooter>
        </>
    );
}
export default FlightAirportLists;
